// extracted by mini-css-extract-plugin
export var acceptButton = "_3o-5";
export var fullContent = "_3o-4";
export var link = "_3o-6";
export var linkIcon = "_3o-7";
export var sideContent = "_3o-3";
export var sideImage = "_3o-2";
export var sideImageWrapper = "_3o-1";
export var splitLayout = "_3o-0";